import { Box } from "@mui/material";
import React, { memo } from "react";
import { Dashboard } from "../../../../../types/files";
import DashboardSelect from "../../../dashboards/DashboardSelect";

const SelectionCell: React.FC<{
    dashboard: Dashboard,
    collectionKey?: string,
}> = ({ dashboard, collectionKey }) => {
    return (<>
        {!!collectionKey ? (
            <DashboardSelect collection={collectionKey} dashboard={dashboard} />
        ) : (<Box width={24} />)}
    </>);
}

export default memo(SelectionCell);
